import isEmpty from './is-empty';

export default function (value) {
    return !isEmpty(value);
}
